module.exports = __webpack_public_path__ + "3697157a23bdcf5b8c7aea538e231ef6.svg";